import { cx } from '@emotion/css';
import { Link } from 'react-router-dom';
import * as styles from './features.style';

export default function Features() {
  const content = [
    {
      id: 1,
      title: 'events',
      line: 'Grade specific quiz programs on a variety of topics such as mathematics, General Knowledge, Space, Countries, Culture etc. Students earn rewards for every quiz they clear.More the rewards more the choices.',
      img: require('../../assets/images/img-4837.jpeg').default,
      link: '/openevents',
      linkText: 'Try it',
      baseColor: '#6bd5ff',
    },
    {
      id: 2,
      title: 'challenges',
      line: 'Challenge your friends or students with a extensive set of predefined questions across multiple grade levels. Create your own quiz and challenge them. See how well they did it.',
      img: require('../../assets/images/imgimg-4838.jpeg').default,
      link: '/assignments',
      linkText: 'Try it',
      baseColor: '#f14ba5',
    },
    {
      id: 3,
      title: 'practices',
      line: 'Practice and learn grade specific topics . We have designed the practice section to filter out questions answered wrong and help students retry them and complete the quizes with any number of retries.',
      img: require('../../assets/images/img-4839.jpeg').default,
      link: '/practiceevents',
      linkText: 'Try it',
      baseColor: '#dd6e2b',
    },
    {
      id: 4,
      title: 'batches',
      line: 'Create batches of students and post them challenges and see how well they did it.',
      img: require('../../assets/images/img-4840.jpeg').default,
      link: '/batch',
      linkText: 'Try it',
      baseColor: '#edc224',
    },
  ];
  return (
    <section className={`container ${styles.featuresSection}`}>
      <h2 className={`text-center ${cx(styles.subHeading)}`}>What we offer</h2>
      <div className={cx(styles.features)}>
        {content.map((item) => (
          <div
            key={item.id}
            style={{ '--base-color': item.baseColor }}
            className={cx(styles.featureItem)}
          >
            <div className={cx(styles.featureInner)}>
              <img className={cx(styles.featureImg)} src={item.img} alt="" />
              <p className={cx(styles.featureTitle)}>{item.title}</p>
              <p className={cx(styles.featureLine)}>{item.line}</p>
              <Link className={cx(styles.featureBtn)} to={item.link}>
                {item.linkText}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
